import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentDetailsModel } from 'api/documents/documents.model';
import Download from 'components/Download/Download';
import SectionTitle from 'components/SectionTitle';
import { CertificateDetailsModel } from 'models/certificate.model';

import * as Styled from './GeneralInformation.styles';
import { generalConfig, GeneralConfigModel } from './generalConfig';

const GeneralInformation = ({
  documentBlockchainAddress,
  fileName,
  additionalDetails,
}: DocumentDetailsModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();

  return (
    <>
      <SectionTitle>{t('certificate.generalInformation')}</SectionTitle>
      <Row gutter={60}>
        {generalConfig.map(({ id }: GeneralConfigModel) => (
          <React.Fragment key={id}>
            <Col md={12} lg={6} style={{ marginBottom: '8px' }}>
              <Styled.Bold>{t(`certificate.general.${id}.label`)}</Styled.Bold>
            </Col>
            <Col md={12} lg={6}>
              {additionalDetails?.[id]}
            </Col>
          </React.Fragment>
        ))}
      </Row>
      {fileName && (
        <>
          <Styled.Bold>{t(`certificate.attachments`)}</Styled.Bold>
          <Download documentId={documentBlockchainAddress} documentName={fileName} />
        </>
      )}
    </>
  );
};

export default GeneralInformation;
